// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__8hfjj","messages":"Chat_messages__3aj6-","dateDivider":"Chat_dateDivider__rKhsr"};